import { configureStore } from '@reduxjs/toolkit';
import userInfoReducer from './userInfoSlice';
import twilioInforReducer from './twilioInfoSlice';
import testVideoReducer from './testVideoSlice';
import streamInfoReducer from './streamInfoSlice';
import seatInfoReducer from './seatInfoSlice';
import globalChatReducer from './globalChatSlice';
import boxChatReducer from './boxChatSlice';
import movingBoxReducer from './movingBoxSlice';
import loginFormReducer from './loginSlice';
import chatSelectReducer from './chatSelectSlice';
import reserveBoxReducer from './reserveBoxSlice';
import newEventReducer from './newEventSlice';
import eventStatusReducer from './eventStatusSlice';
import participantListReducer from './participantListSlice';
import eventAsGuestReducer from './eventAsGuestSlice';
import watcheventTourReducer from './watcheventTourSlice';

const store = configureStore({
  reducer: {
    userInfo: userInfoReducer,
    twilioInfo: twilioInforReducer,
    testVideo: testVideoReducer,
    streamInfo: streamInfoReducer,
    seatInfo: seatInfoReducer,
    globalChat: globalChatReducer,
    boxChat: boxChatReducer,
    movingBox: movingBoxReducer,
    loginForm: loginFormReducer,
    chatSelect: chatSelectReducer,
    reserveBox: reserveBoxReducer,
    newEvent: newEventReducer,
    eventStatus: eventStatusReducer,
    participantList: participantListReducer,
    eventAsGuest: eventAsGuestReducer,
    watcheventTour: watcheventTourReducer,
  },
});

export default store;
